// external dependencies
import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { SearchContext } from './SearchProvider'

// components
import Dropdown from 'components/Dropdown'

// styled components
const DropdownContainer = styled.div`
	display: flex;
	justify-content: center;

	${({ theme }) => theme.MQ.M} {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
`

// constants
const SEARCH_SORT_OPTIONS = [
	{ label: 'Relevant', value: '0' },
	{ label: 'Latest', value: '1' },
]

const SEARCH_FILTER_OPTIONS = [
	{ label: 'Filter', value: '0' },
	{ label: 'Past Week', value: '1' },
	{ label: 'Past Month', value: '2' },
	{ label: 'Past Year', value: '3' },
]

function SearchFilterSort() {
	const { filter, handleSortFilter, sort } = useContext(SearchContext)
	return (
		<DropdownContainer>
			<Dropdown
				defaultSelected={filter}
				id="filter"
				handleChangeOnSelect={handleSortFilter}
				options={SEARCH_FILTER_OPTIONS}
			/>
			<Dropdown
				defaultSelected={sort}
				id="sort"
				handleChangeOnSelect={handleSortFilter}
				options={SEARCH_SORT_OPTIONS}
			/>
		</DropdownContainer>
	)
}

export default SearchFilterSort
